<template>
  <div class="col-12 col-xl-6">
    <div class="card h-100 border-translucent card-hover">
      <div class="card-body d-flex flex-column">
        <div class="d-flex align-items-start mb-3">
          <div v-if="icon" class="flex-shrink-0 me-3">
            <div
              class="icon-wrapper d-flex align-items-center justify-content-center"
            >
              <font-awesome-icon :icon="icon" class="text-primary" size="lg" />
            </div>
          </div>
          <div class="flex-grow-1">
            <h5 class="card-title mb-1">{{ title }}</h5>
            <p class="card-text text-muted small mb-2">
              {{ description }}
            </p>
            <slot name="badge"></slot>
          </div>
          <div v-if="infoText" class="flex-shrink-0 ms-2">
            <InfoTooltip :text="infoText" :showIcon="false">
              <font-awesome-icon
                icon="fa-solid fa-circle-info"
                class="info-icon"
              />
            </InfoTooltip>
          </div>
        </div>

        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InfoTooltip from "@/components/common/InfoTooltip.vue";

defineProps<{
  title: string;
  description: string;
  icon?: string;
  infoText?: string;
}>();
</script>

<style scoped lang="scss">
.card-hover {
  transition: all 0.2s ease-in-out;
  cursor: default;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  background-color: rgba(var(--phoenix-primary-rgb), 0.1);
  border-radius: 0.5rem;
}

.info-icon {
  cursor: help;
  font-size: 1.5rem;
  color: rgba(var(--phoenix-body-color-rgb), 0.3);
  transition: color 0.2s ease;

  &:hover {
    color: rgba(var(--phoenix-body-color-rgb), 0.6);
  }
}
</style>
